import { render, staticRenderFns } from "./StageCommentModal.vue?vue&type=template&id=f122e036&scoped=true"
import script from "./StageCommentModal.vue?vue&type=script&lang=js"
export * from "./StageCommentModal.vue?vue&type=script&lang=js"
import style0 from "./StageCommentModal.vue?vue&type=style&index=0&id=f122e036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f122e036",
  null
  
)

export default component.exports